import React, { useCallback } from 'react'

import { isObject } from 'lodash'
import { useIntl } from 'react-intl'

import appConfig from 'config/appConfig'
import { useAppSelector } from 'redux/toolkit/hooks'
import globalMessages from 'config/i18n/en.json'
import domainMessages from 'config/i18n/tabs/domains_en.json'
import inboundMessages from 'config/i18n/tabs/inbound_settings_en.json'
import outboundMessages from 'config/i18n/tabs/outbound_settings_en.json'
import overviewMessages from 'config/i18n/tabs/overview_en.json'
import usersMessages from 'config/i18n/tabs/users_en.json'
import v2Messages from 'config/i18n/v2/en.json'
import supportMessages from 'config/i18n/support_en.json'
import MESSAGES_EN from 'config/i18n/en'
import MESSAGES_ES from 'config/i18n/es'
import MESSAGES_JA from 'config/i18n/ja'

import esMessages from 'config/i18n/es.json'
import esDomainMessages from 'config/i18n/tabs/domains_es.json'
import esInboundMessages from 'config/i18n/tabs/inbound_settings_es.json'
import esOutboundMessages from 'config/i18n/tabs/outbound_settings_es.json'
import esOverviewMessages from 'config/i18n/tabs/overview_es.json'
import esUsersMessages from 'config/i18n/tabs/users_es.json'
import esV2Messages from 'config/i18n/v2/es.json'
import esSupportMessages from 'config/i18n/support_es.json'
import WIZARD_MESSAGES_ES_JSON from 'config/i18n/wizard_es.json'
import CUDASPT_MESSAGES_ES_JSON from 'config/i18n/cudaspt_es.json'

import jaMessages from 'config/i18n/ja.json'
import jaDomainMessages from 'config/i18n/tabs/domains_ja.json'
import jaInboundMessages from 'config/i18n/tabs/inbound_settings_ja.json'
import jaOutboundMessages from 'config/i18n/tabs/outbound_settings_ja.json'
import jaOverviewMessages from 'config/i18n/tabs/overview_ja.json'
import jaUsersMessages from 'config/i18n/tabs/users_ja.json'
import jaV2Messages from 'config/i18n/v2/ja.json'
import jaSupportMessages from 'config/i18n/support_ja.json'
import WIZARD_MESSAGES_JA_JSON from 'config/i18n/wizard_ja.json'
import CUDASPT_MESSAGES_JA_JSON from 'config/i18n/cudaspt_ja.json'

import frMessages from 'config/i18n/fr.json'
import frDomainMessages from 'config/i18n/tabs/domains_fr.json'
import frInboundMessages from 'config/i18n/tabs/inbound_settings_fr.json'
import frOutboundMessages from 'config/i18n/tabs/outbound_settings_fr.json'
import frOverviewMessages from 'config/i18n/tabs/overview_fr.json'
import frUsersMessages from 'config/i18n/tabs/users_fr.json'
import frV2Messages from 'config/i18n/v2/fr.json'
import frSupportMessages from 'config/i18n/support_fr.json'
import WIZARD_MESSAGES_FR_JSON from 'config/i18n/wizard_fr.json'
import CUDASPT_MESSAGES_FR_JSON from 'config/i18n/cudaspt_fr.json'

import itMessages from 'config/i18n/it.json'
import itDomainMessages from 'config/i18n/tabs/domains_it.json'
import itInboundMessages from 'config/i18n/tabs/inbound_settings_it.json'
import itOutboundMessages from 'config/i18n/tabs/outbound_settings_it.json'
import itOverviewMessages from 'config/i18n/tabs/overview_it.json'
import itUsersMessages from 'config/i18n/tabs/users_it.json'
import itV2Messages from 'config/i18n/v2/it.json'
import itSupportMessages from 'config/i18n/support_it.json'
import WIZARD_MESSAGES_IT_JSON from 'config/i18n/wizard_it.json'
import CUDASPT_MESSAGES_IT_JSON from 'config/i18n/cudaspt_it.json'

import deMessages from 'config/i18n/de.json'
import deDomainMessages from 'config/i18n/tabs/domains_de.json'
import deInboundMessages from 'config/i18n/tabs/inbound_settings_de.json'
import deOutboundMessages from 'config/i18n/tabs/outbound_settings_de.json'
import deOverviewMessages from 'config/i18n/tabs/overview_de.json'
import deUsersMessages from 'config/i18n/tabs/users_de.json'
import deV2Messages from 'config/i18n/v2/de.json'
import deSupportMessages from 'config/i18n/support_de.json'
import WIZARD_MESSAGES_DE_JSON from 'config/i18n/wizard_de.json'
import CUDASPT_MESSAGES_DE_JSON from 'config/i18n/cudaspt_de.json'

import nlMessages from 'config/i18n/nl.json'
import nlDomainMessages from 'config/i18n/tabs/domains_nl.json'
import nlInboundMessages from 'config/i18n/tabs/inbound_settings_nl.json'
import nlOutboundMessages from 'config/i18n/tabs/outbound_settings_nl.json'
import nlOverviewMessages from 'config/i18n/tabs/overview_nl.json'
import nlUsersMessages from 'config/i18n/tabs/users_nl.json'
import nlV2Messages from 'config/i18n/v2/nl.json'
import nlSupportMessages from 'config/i18n/support_nl.json'
import WIZARD_MESSAGES_NL_JSON from 'config/i18n/wizard_nl.json'
import CUDASPT_MESSAGES_NL_JSON from 'config/i18n/cudaspt_nl.json'

import WIZARD_MESSAGES_EN_JSON from 'config/i18n/wizard_en.json'
import CUDASPT_MESSAGES_EN_JSON from 'config/i18n/cudaspt_en.json'
import WIZARD_MESSAGES_EN from 'config/i18n/wizard_en'
import CUDASPT_MESSAGES_EN from 'config/i18n/cudaspt_en'
import LANGUAGE_NAMES from 'config/i18n/common'

import {
  helpMessagesEn,
  helpMessagesJa,
  helpMessagesEs,
  helpMessagesFr,
  helpMessagesDe,
  helpMessagesIt,
  helpMessagesNl
} from 'config/i18n/help'

import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'
import logger from 'lib/logger'

export type MissedLocalization = {
  key: string
  value: string
}

interface Messages {
  [key: string]: Record<string, any> | string
}

interface MessagesCollection {
  [key: string]: Record<string, any>
}

export interface Localization {
  locale: string
  messages: Record<string, any>
}

const MESSAGES_EN_JSON = {
  ess: {
    ...globalMessages.ess,
    ...domainMessages,
    ...inboundMessages,
    ...outboundMessages,
    ...overviewMessages,
    ...usersMessages,
    ...v2Messages,
    ...supportMessages,
    ...helpMessagesEn
  }
}

const MESSAGES_ES_JSON = {
  ess: {
    ...esMessages.ess,
    ...esDomainMessages,
    ...esInboundMessages,
    ...esOutboundMessages,
    ...esOverviewMessages,
    ...esUsersMessages,
    ...esV2Messages,
    ...esSupportMessages,
    ...helpMessagesEs
  },
  ...WIZARD_MESSAGES_ES_JSON,
  ...CUDASPT_MESSAGES_ES_JSON
}

const MESSAGES_JA_JSON = {
  ess: {
    ...jaMessages.ess,
    ...jaDomainMessages,
    ...jaInboundMessages,
    ...jaOutboundMessages,
    ...jaOverviewMessages,
    ...jaUsersMessages,
    ...jaV2Messages,
    ...jaSupportMessages,
    ...helpMessagesJa
  },
  ...WIZARD_MESSAGES_JA_JSON,
  ...CUDASPT_MESSAGES_JA_JSON
}

const MESSAGES_FR_JSON = {
  ess: {
    ...frMessages.ess,
    ...frDomainMessages,
    ...frInboundMessages,
    ...frOutboundMessages,
    ...frOverviewMessages,
    ...frUsersMessages,
    ...frV2Messages,
    ...frSupportMessages,
    ...helpMessagesFr
  },
  ...WIZARD_MESSAGES_FR_JSON,
  ...CUDASPT_MESSAGES_FR_JSON
}

const MESSAGES_IT_JSON = {
  ess: {
    ...itMessages.ess,
    ...itDomainMessages,
    ...itInboundMessages,
    ...itOutboundMessages,
    ...itOverviewMessages,
    ...itUsersMessages,
    ...itV2Messages,
    ...itSupportMessages,
    ...helpMessagesIt
  },
  ...WIZARD_MESSAGES_IT_JSON,
  ...CUDASPT_MESSAGES_IT_JSON
}

const MESSAGES_DE_JSON = {
  ess: {
    ...deMessages.ess,
    ...deDomainMessages,
    ...deInboundMessages,
    ...deOutboundMessages,
    ...deOverviewMessages,
    ...deUsersMessages,
    ...deV2Messages,
    ...deSupportMessages,
    ...helpMessagesDe
  },
  ...WIZARD_MESSAGES_DE_JSON,
  ...CUDASPT_MESSAGES_DE_JSON
}

const MESSAGES_NL_JSON = {
  ess: {
    ...nlMessages.ess,
    ...nlDomainMessages,
    ...nlInboundMessages,
    ...nlOutboundMessages,
    ...nlOverviewMessages,
    ...nlUsersMessages,
    ...nlV2Messages,
    ...nlSupportMessages,
    ...helpMessagesNl
  },
  ...WIZARD_MESSAGES_NL_JSON,
  ...CUDASPT_MESSAGES_NL_JSON
}

const TS_DEFAULT_MESSAGES = { ...MESSAGES_EN, ...WIZARD_MESSAGES_EN, ...CUDASPT_MESSAGES_EN }
const JSON_DEFAULT_MESSAGES = {
  ...MESSAGES_EN_JSON,
  ...WIZARD_MESSAGES_EN_JSON,
  ...CUDASPT_MESSAGES_EN_JSON
}

function getLocalizations(): Record<string, Messages> {
  let isSmartlingTranslationsEnabled = false // Default to TS
  try {
    isSmartlingTranslationsEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    logger.info('falied to check split-flag: EGD_React_Smartling_Translations')
  }

  if (isSmartlingTranslationsEnabled) {
    return {
      en_US: MESSAGES_EN_JSON,
      es_ES: MESSAGES_ES_JSON,
      ja_JP: MESSAGES_JA_JSON,
      fr_FR: MESSAGES_FR_JSON,
      it_IT: MESSAGES_IT_JSON,
      de_DE: MESSAGES_DE_JSON,
      nl_NL: MESSAGES_NL_JSON
    }
  }
  return {
    en_US: MESSAGES_EN,
    es_ES: MESSAGES_ES,
    ja_JP: MESSAGES_JA
  }
}

function getDefaultMessages() {
  let isSmartlingTranslationsEnabled = false // Default to TS
  try {
    isSmartlingTranslationsEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    logger.info('falied to check split-flag: EGD_React_Smartling_Translations')
  }

  if (isSmartlingTranslationsEnabled) {
    // Only include English defaults - other languages are applied via LOCALIZATIONS[effectiveLocale]
    // Previously all languages were merged here with Dutch last, causing Dutch wizard/cudaspt
    // messages to overwrite English defaults when an unknown locale fell back to en_US
    return {
      ...JSON_DEFAULT_MESSAGES,
      ...LANGUAGE_NAMES
    }
  }
  return {
    ...TS_DEFAULT_MESSAGES,
    ...LANGUAGE_NAMES
  }
}

const APP_NAMESPACE = 'ess'

function collectAppMessages(messages: Messages) {
  function stringifyKeys(messagesBlock: MessagesCollection, prefix = ''): MessagesCollection {
    const updatedPrefix = prefix === `${appConfig.NAME}.` ? `${prefix}${APP_NAMESPACE}.` : prefix

    return Object.keys(messagesBlock).reduce((all, messageId) => {
      if (isObject(messagesBlock[messageId])) {
        return {
          ...all,
          ...stringifyKeys(messagesBlock[messageId], `${updatedPrefix}${messageId}.`)
        }
      }

      return {
        ...all,
        [`${updatedPrefix}${messageId}`]: messagesBlock[messageId]
      }
    }, {})
  }

  const collectedMessages = Object.keys(messages).reduce((all, messageId) => {
    if (messageId.includes(appConfig.NAME.toLocaleLowerCase())) {
      return {
        ...all,
        [messageId.replace(`${appConfig.NAME}.`, '')]: messages[messageId]
      }
    }

    return all
  }, {} as Record<string, any>)

  return stringifyKeys(collectedMessages)
}

export const useFormatMessage = (baseKey: string) => {
  const { language } = useAppSelector(_store => ({
    language: _store.app.language
  }))
  const intl = useIntl()

  const formatMessage = useCallback(
    (path: string, data = {}) =>
      intl.formatMessage(
        {
          id: `${baseKey}.${path}`
        },
        {
          b: (txt: any): any => <b>{txt}</b>,
          i: (txt: any): any => <i>{txt}</i>,
          code: (txt: any): any => <code>{txt}</code>,
          ...data
        }
      ),
    // language is needed in the dependency array to force creating a new formatMessage function when language is changing in redux
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [baseKey, intl, language]
  )
  return formatMessage
}

export const useErrorFormatMessage = () => useFormatMessage('ess.app.error')

export const collectMissedLocalizationKeys = () => {
  const enMessages = collectAppMessages({ ...MESSAGES_EN, ...WIZARD_MESSAGES_EN, ...CUDASPT_MESSAGES_EN })
  const tableDivider = { key: '-'.repeat(50), value: '-'.repeat(50) }
  const LOCALIZATIONS = getLocalizations()

  Object.keys(LOCALIZATIONS).forEach((lang: string) => {
    if (lang !== 'en_US') {
      const langInstance = { key: (LANGUAGE_NAMES.ess_language.language as any)[lang], value: lang }
      const missedTranslates: MissedLocalization[] = []
      const localizationMessages = collectAppMessages(LOCALIZATIONS[lang])

      Object.keys(collectAppMessages(enMessages)).forEach((enKey: string) => {
        // skip the cudaspt entries
        if (!Object.prototype.hasOwnProperty.call(localizationMessages, enKey) && !enKey.includes('cudaspt')) {
          missedTranslates.push({ key: enKey, value: enMessages[enKey] as any })
        }
      })

      if (missedTranslates.length && window) {
        // eslint-disable-next-line
        window.__egd__ = {
          // eslint-disable-next-line
          getMissedTranslates: () => console.table([langInstance, tableDivider, ...missedTranslates])
        }
      }
    }
  })
}

export default function initLocalization(localization: string): Localization {
  if (appConfig.ENVIRONMENT.IS_DEV || appConfig.ENVIRONMENT.IS_GT3 || appConfig.ENVIRONMENT.IS_VT2) {
    collectMissedLocalizationKeys()
  }
  const DEFAULT_MESSAGES = getDefaultMessages()
  const LOCALIZATIONS = getLocalizations()
  const effectiveLocale = localization in LOCALIZATIONS ? localization : 'en_US'

  return {
    messages: {
      ...collectAppMessages(DEFAULT_MESSAGES),
      ...collectAppMessages(LOCALIZATIONS[effectiveLocale])
    },
    locale: effectiveLocale.replace('_', '-')
  }
}
